export default __webpack_public_path__ + "static/media/q11_step4.85b91f16.png";